import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AdminAddNotesComponent } from "../admin-add-notes/admin-add-notes.component";
import { AdminService } from "../admin.service";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AddDriverRouteComponent } from "../add-driver-route/add-driver-route.component";
import { AdminCreateDriverRouteComponent } from "../admin-create-driver-route/admin-create-driver-route.component";
import { ViewDriverRouteComponent } from "../view-driver-route/view-driver-route.component";
import { CommonServices } from "src/app/common.services";

@Component({
  selector: "app-admin-driver-orders",
  templateUrl: "./admin-driver-orders.component.html",
  styleUrls: ["./admin-driver-orders.component.css"],
})
export class AdminDriverOrdersComponent implements OnInit {
  tripType: any = "-1";
  fetch_page: any = 0;
  startPage: any = 1;
  last_page: any = 1;
  document_array: any = [];
  searchtripID: any = -1;
  currentPage: any = 0;
  token: any;
  perPage: any = 10;
  SelectedNumber: number = 0;
  driverSelectedIds: any = [];
  driverOrdersList: any = [];
  loading: boolean = false;
  searchButton: boolean = true;
  toggleSearch: boolean = false;
  selectDriverRoute: boolean = true;
  cancelDriverRoute: boolean = false;
  deleteDriverRoute: boolean = false;
  DeleteAction: boolean = false;
  checkBox: boolean = false;
  paginationTrips: boolean = true;
  allTrips: boolean = true;
  liveTrips: boolean = false;
  dr_Status: any = -1;
  search_query: any = -1;
  route_fare: any;
  MatDialogref!: MatDialogRef<AdminAddNotesComponent>;
  matDialogRef: MatDialogRef<AddDriverRouteComponent>;
  createDialogRef!: MatDialogRef<AdminCreateDriverRouteComponent>;
  matdialogRef: MatDialogRef<ViewDriverRouteComponent>;
  clear_Btn: boolean = false;
  isInputValid: boolean = false;
  previousValue: string = "";
  private lengthState: number = 0;
  search_Btn: boolean = true;
  @ViewChild("newItem") newItem: ElementRef;
  @ViewChild("newItem", { static: false }) inputElement!: ElementRef;

  constructor(
    private MatDialog: MatDialog,
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar,
    private commonServices: CommonServices
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.getDriversRoutes(this.searchtripID);
    let triptype = "driverOrders";
    localStorage.setItem("tripType", triptype);
    // this.pagination(1);
    const savedPage = sessionStorage.getItem("lastDriverOrdersFetchPage");
    this.fetch_page = savedPage ? parseInt(savedPage) : 1;

    this.startPage = this.fetch_page;
    this.currentPage = this.fetch_page;
    this.commonServices.getPublishedEvent("driverRoutes").subscribe({
      next: (data: any) => {
        if (data) {
          this.getDriversRoutes(this.searchtripID);
        }
      },
      error: (error) => {
        console.error("❌ Error received:", error);
        this.loading = false;
      },
      complete: () => console.log("✅ Subscription completed."),
    });
  }

  onInputChange(input: HTMLInputElement) {
    const value = input.value;
    const previousLength = this.previousValue.length;
    this.previousValue = value;

    if (this.previousValue.length > previousLength && this.clear_Btn) {
      this.callApi();
      this.search_Btn = true;
      this.clear_Btn = false;
    }

    const containsSpecialChars = /[^\w\d]/.test(value);
    if (containsSpecialChars) {
      input.value = value.replace(/[^\w\d]/g, "");
      this.snackBar.open("Special characters are not allowed", "Fail", {
        duration: 5000,
      });
      return;
    }

    this.isInputValid = value.length >= 4;
    switch (previousLength) {
      case 10:
        if (value.length === 9 && this.lengthState !== 9) {
          this.lengthState = 9;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 9:
        if (value.length === 8 && this.lengthState !== 8) {
          this.lengthState = 8;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 8:
        if (value.length === 7 && this.lengthState !== 7) {
          this.lengthState = 7;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 7:
        if (value.length === 6 && this.lengthState !== 6) {
          this.lengthState = 6;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 6:
        if (value.length === 5 && this.lengthState !== 5) {
          this.lengthState = 5;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 5:
        if (value.length === 4 && this.lengthState !== 4) {
          this.lengthState = 4;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 4:
        if (value.length === 3 && this.lengthState !== 3) {
          this.lengthState = 3;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      default:
        if (value.length >= 4) {
          this.lengthState = 0;
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;
    }

    // if (value.length > 10) {
    //   input.value = value.substring(0, 10);
    //   this.snackBar.open("Registration Number Limit Exceeded", "Fail", {
    //     duration: 5000,
    //   });
    // }

    if (value.length === 0) {
      this.resetSearch();
    }
  }

  resetSearch() {
    this.newItem.nativeElement.value = "";
    this.searchtripID = -1;
    this.fetch_page = 1;
    this.getDriversRoutes(this.searchtripID);
    this.toggleSearch = false;
    this.searchButton = true;
    this.checkBox = false;
    this.DeleteAction = false;
    this.cancelDriverRoute = false;
  }

  private callApi() {
    this.searchtripID = -1;
    this.fetch_page = 1;
    this.getDriversRoutes(this.searchtripID);
    this.fetch_page = 0;
    this.pagination(1);
  }

  // onInput(event: any): void {
  //   const input = event.target.value;
  //   event.target.value = input.replace(/[^0-9]/g, "");
  // }

  getDriversRoutes(type: any) {
    this.loading = true;
    this.search_query = type;

    this.services
      .getDriverRoutes(
        this.token,
        this.dr_Status,
        this.search_query,
        this.perPage,
        this.startPage,
        this.tripType
      )
      .subscribe(
        (response) => {
          if (response.status === 200) {
            this.driverOrdersList = response.body.data;
            this.document_array.push(response.body.meta);
            this.last_page = response.body.meta.lastPage;
            this.loading = false;
          }
        },
        (error) => {
          this.driverOrdersList = [];
          this.loading = false;
          if (error.status == 404) {
            this.paginationTrips = false;
            return;
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");

            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  openCreateDRO() {
    this.createDialogRef = this.MatDialog.open(
      AdminCreateDriverRouteComponent,
      {
        width: "90vw",
        maxWidth: "800px",
        data: {},
        autoFocus: false,
      }
    );
    this.createDialogRef.afterClosed().subscribe((res: any) => {
      if (res && res.event === "Success") {
        this.getDriversRoutes(this.searchtripID);
      }
    });
  }

  editDriver(item: any) {
    this.matDialogRef = this.MatDialog.open(AddDriverRouteComponent, {
      width: "80vw",
      height: "80vh",
      data: item,
      autoFocus: false,
    });
    this.matDialogRef.afterClosed().subscribe((x) => {
      this.getDriversRoutes(this.searchtripID);
    });
  }

  viewDriver(item: any) {
    this.matdialogRef = this.MatDialog.open(ViewDriverRouteComponent, {
      width: "80vw",
      height: "80vh",
      data: item,
      autoFocus: false,
    });
    this.matdialogRef.afterClosed().subscribe((x) => {
      this.getDriversRoutes(this.searchtripID);
    });
  }

  getTripsList(selectedTripType: any) {
    this.loading = true;
    this.tripType = selectedTripType;
    // Save tripType to localStorage
    localStorage.setItem("lastTripType", this.tripType);

    if (selectedTripType == "-1") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.paginationTrips = true;
      this.getDriversRoutes(this.searchtripID);
      this.document_array = [];
    } else if (selectedTripType == "activeRoutes") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.paginationTrips = true;
      this.getDriversRoutes(this.searchtripID);
      this.document_array = [];
    } else if (selectedTripType == "liveTrips") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.paginationTrips = true;
      this.getDriversRoutes(this.searchtripID);
      this.document_array = [];
    } else if (selectedTripType == "completed") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.paginationTrips = true;
      this.getDriversRoutes(this.searchtripID);
      this.document_array = [];
    } else if (selectedTripType == "cancelled") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.paginationTrips = true;
      this.getDriversRoutes(this.searchtripID);
      this.document_array = [];
    }
  }
  GoToAllTrips() {
    this.allTrips = true;
    this.liveTrips = false;
  }

  public selectDriver() {
    this.searchButton = true;
    this.cancelDriverRoute = true;
    this.deleteDriverRoute = true;
    this.checkBox = true;
    this.toggleSearch = false;
    this.selectDriverRoute = false;
  }
  public cancelDriver() {
    this.selectDriverRoute = true;
    this.searchButton = true;
    this.cancelDriverRoute = false;
    this.deleteDriverRoute = false;
    this.toggleSearch = false;
    this.checkBox = false;
    this.DeleteAction = false;
    this.SelectedNumber = 0;
    this.searchtripID = -1;
    this.fetch_page = 1;
    this.getDriversRoutes(this.searchtripID);
  }

  public deleteDriver() {}

  public matItem(event: any, item: any, index: number) {
    if (event.checked) {
      this.driverSelectedIds.push(item);
      this.SelectedNumber += 1;
      this.DeleteAction = true;
    } else {
      this.driverSelectedIds.splice(index, 1);
      this.SelectedNumber -= 1;
      this.driverSelectedIds = [];
    }
  }

  GoToLiveTrips() {
    this.liveTrips = true;
    this.allTrips = false;
  }

  openSearch() {
    this.toggleSearch = true;
    this.searchButton = false;
    this.selectDriverRoute = false;
    this.cancelDriverRoute = true;
    this.deleteDriverRoute = false;
    this.checkBox = false;

    this.search_Btn = true;
    this.clear_Btn = false;
    this.DeleteAction = true;
    if (this.toggleSearch) {
      setTimeout(() => this.inputElement.nativeElement.focus(), 0);
    }
  }

  search(value: any) {
    if (value != "") {
      this.search_Btn = false;
      this.clear_Btn = true;
      this.startPage = 1;
      this.getDriversRoutes(value);
    }
  }

  addNotes(tripId: any) {
    this.MatDialogref = this.MatDialog.open(AdminAddNotesComponent, {
      width: "40vw",
      data: {
        _id: tripId,
        module_type: "driverorder",
      },
      autoFocus: false,
    });
  }
  
  pagination(page_status: any) {
    let newPage = this.fetch_page;

    if (page_status == "-1") {
      newPage = Math.max(1, this.fetch_page - 1); // Prevent negative pages
    } else if (page_status == "1") {
      newPage = this.fetch_page + 1;
    } else if (page_status == "first") {
      newPage = 1; // Set the first page correctly
    } else if (page_status == "last") {
      newPage = this.last_page || 1; // Ensure last page is fetched correctly
    }

    this.fetch_page = newPage;
    this.currentPage = newPage;
    this.startPage = newPage;

    // Save current page to localStorage
    sessionStorage.setItem("lastDriverOrdersFetchPage", newPage.toString());

    this.getDriversRoutes(this.searchtripID);
  }

  getTransporterTotalPaid(truckownerPaymentInfo: any[]): number {
    if (!truckownerPaymentInfo || !truckownerPaymentInfo.length) {
      return 0;
    }
    return truckownerPaymentInfo.reduce((sum, p) => sum + (Number(p.transaction_amount) || 0), 0);
  }

  getTransporterFare(item: any): number {
    if (!item) return 0;
    const userType = item.trip_details?.[0]?.userInfo?.user_type || item.trip_details?.[0]?.userInfo?.[0]?.user_type;
    if (userType === 'corporate') {
      const payAs = item.workorderInfo?.[0]?.pay_as_load_quantity;
      const otherDetails = item.tripInfo?.workOrderOtherDetails;
      const pricePerTon = Number(otherDetails?.price_per_ton) || 0;
      if (payAs === 'loaded_quantity') {
        return (Number(otherDetails?.loading_point) || 0) * pricePerTon;
      } else if (payAs === 'unloaded_quantity') {
        const qty = Number(otherDetails?.unloading_point) || Number(otherDetails?.loading_point) || 0;
        return qty * pricePerTon;
      }
      return Number(item.total_fare) || 0;
    }
    return Number(item.total_fare) || 0;
  }
}
